import React from 'react'
import Image from '../../../images/buyerpolicies/Our Contract.png'

const Our_contract = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Our Contract</h2>
            <p>You will always receive an email for acknowledgment of your order whenever you place one. You should be aware that this email is only for acknowledgment of the order and does not mean acceptance.</p>
            <p>The contract between you and KAAY is not established unless you receive a confirmation by e-mail that the goods and products you ordered have been mailed to you. The goods mentioned in the email are part of the buying/selling contract only.</p>
        </div>
      </div>
    </div>
  )
}

export default Our_contract
